import {debounce} from './form-utils.js';

function adaptDonationButtonHeight(components) {
  components.forEach((container) => {
    const form = container.querySelector(':scope > form');
    const donationOptions = form?.querySelector(':scope > .donation-options')
      || form?.querySelector('.donation-options');

    if (!form || !donationOptions?.scrollHeight) {
      return;
    }

    const height = window.innerWidth >= 768
      ? donationOptions.scrollHeight + 20
      : donationOptions.scrollHeight;

    form.style.display = 'block';
    form.style.height = `${height}px`;
  });
}

function addSalutationLabel(container) {
  const salutationInput = container.querySelector('#enupalStripe-salutation');
  const salutationLabel = container.querySelector('label[for="enupalStripe-salutation"]');

  if (!salutationInput || !salutationLabel || salutationInput.querySelector('[data-inline-salutation-label]')) {
    return;
  }

  const inlineLabel = document.createElement('span');
  inlineLabel.dataset.inlineSalutationLabel = 'true';
  inlineLabel.innerText = salutationLabel.innerText;
  salutationInput.prepend(inlineLabel);
}

export async function initDonationInlineComponents(root = document) {
  const components = [...root.querySelectorAll('[data-inline-donation]')]
    .filter((component) => component.dataset.inlineDonationInitialized !== 'true');

  if (components.length === 0) {
    return;
  }

  components.forEach((component) => {
    component.dataset.inlineDonationInitialized = 'true';
  });

  try {
    await import('../../custom-stripe.js');
  } catch (error) {
    console.error('Failed to load custom-stripe.js', error);
    return;
  }

  adaptDonationButtonHeight(components);
  window.addEventListener('resize', debounce(() => adaptDonationButtonHeight(components), 500));

  components.forEach((component) => {
    component.querySelectorAll('.donate-form-option').forEach((option) => {
      option.addEventListener('click', (event) => {
        const form = event.target.closest('form');

        if (!form || form.classList.contains('fold')) {
          return;
        }

        form.classList.add('fold');
        form.style.visibility = 'visible';
        form.style.height = `${form.scrollHeight}px`;
      });
    });

    addSalutationLabel(component);
  });
}
